/**
 * @fileoverview gta renderer.
 * @author gtaer
 */
"use strict";

import Blockly from "blockly";
import "./info";
import "./block_svg";

/**
 * An object that draws a block based on the given rendering information.
 * @param {!Blockly.BlockSvg} block The block to render.
 * @param {!Blockly.gta.RenderInfo} info An object containing all
 *   information needed to render this block.
 * @package
 * @constructor
 * @extends {Blockly.blockRendering.Drawer}
 */
Blockly.gta.Drawer = function(block, info) {
  Blockly.gta.Drawer.superClass_.constructor.call(this, block, info);
};
Blockly.utils.object.inherits(
  Blockly.gta.Drawer,
  Blockly.blockRendering.Drawer
);

/**
 * @override
 * 画外部框架
 * 此处判断和控制积木svg路径
 */
Blockly.gta.Drawer.prototype.drawOutline_ = function() {
  this.block_.pathObject.svgPath.classList.add(this.block_.type);
  if (this.info_.outputConnection && this.info_.outputConnection.isDynamic()) {
    this.drawFlatTop_();
    this.drawRightDynamicConnection_();
    this.drawFlatBottom_();
    this.drawLeftDynamicConnection_();
  } else {
    Blockly.gta.Drawer.superClass_.drawOutline_.call(this);
  }

  this.strokeOpacityTransform(); //调用改变积木渐变
};

// 基本样式绘图
// Blockly.blockRendering.Drawer.prototype.drawOutline_ = function() {
//   this.drawTop_();
//   for (var r = 1; r < this.info_.rows.length - 1; r++) {
//     var row = this.info_.rows[r];

//     if (row.hasJaggedEdge) {
//       this.drawJaggedEdge_(row);
//     } else if (row.hasStatement) {
//       this.drawStatementInput_(row);
//     } else if (row.hasExternalInput) {
//       this.drawValueInput_(row);
//     } else {
//       this.drawRightSideRow_(row);
//     }
//   }
//   this.drawBottom_();
//   this.drawLeft_();
// };

/**
 * Add steps for the top corner of the block, taking into account
 * details such as hats and rounded corners.
 * 积木svg头部路径
 * @protected
 */

Blockly.gta.Drawer.prototype.drawTop_ = function() {
  var topRow = this.info_.topRow;
  var elements = topRow.elements;
  this.positionPreviousConnection_();
  this.outlinePath_ += Blockly.utils.svgPaths.moveBy(
    topRow.xPos,
    this.info_.startY
  );
  for (var i = 0, elem; (elem = elements[i]); i++) {
    if (Blockly.blockRendering.Types.isLeftRoundedCorner(elem)) {
      this.outlinePath_ += this.constants_.OUTSIDE_CORNERS.topLeft;
    } else if (Blockly.blockRendering.Types.isRightRoundedCorner(elem)) {
      this.outlinePath_ += this.constants_.OUTSIDE_CORNERS.topRight;
    } else if (Blockly.blockRendering.Types.isPreviousConnection(elem)) {
      this.outlinePath_ += elem.shape.pathLeft;
    } else if (Blockly.blockRendering.Types.isHat(elem)) {
      this.outlinePath_ += this.constants_.START_HAT.path;
    } else if (Blockly.blockRendering.Types.isSpacer(elem)) {
      this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis("h", elem.width);
    }
    // No branch for a square corner because it's a no-op.
  }
  this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis("v", topRow.height);
  // console.log("drawTop_:" + this.outlinePath_);
};

// 是否有输入语句
Blockly.gta.Drawer.prototype.hasStatement = function() {
  var hasStatement = false;
  for (var r = 1; r < this.info_.rows.length - 1; r++) {
    var row = this.info_.rows[r];
    if (row.hasStatement) {
      hasStatement = true;
    }
  }
  return hasStatement;
};
/**
 * Add steps for the bottom edge of a block, possibly including a notch
 * for the next connection
 * 积木右侧svg底部路径
 * @protected
 */
Blockly.gta.Drawer.prototype.drawBottom_ = function() {
  var TAB_HEIGHT = this.constants_.TAB_HEIGHT; //左侧输出的高度
  var TAB_WIDTH = this.constants_.TAB_WIDTH; //左侧输出的宽度
  var TAB_OFFSET_FROM_TOP = this.constants_.TAB_OFFSET_FROM_TOP; //偏移的距离;

  var bottomRow = this.info_.bottomRow;
  var halfBottomRow = this.info_.bottomRow.baseline / 2;
  var elems = bottomRow.elements;
  this.positionNextConnection_();
  //默认
  var rightCornerYOffset = 0;
  var outlinePath = "";
  var statement = this.hasStatement();
  if (!statement) {
    // if (this.info_.outputConnection && this.info_.outputConnection.isDynamic()) {
    // 删除右侧的路径
    var index = this.outlinePath_.indexOf("v");
    var delString = this.outlinePath_.slice(index);
    this.outlinePath_ = this.outlinePath_.replace(delString, "");
    var totalHeight = halfBottomRow * 2;
    this.outlinePath_ += this.rightHexagonal(totalHeight);
    // debugger;
  }

  for (var i = elems.length - 1, elem; (elem = elems[i]); i--) {
    if (Blockly.blockRendering.Types.isNextConnection(elem)) {
      outlinePath += elem.shape.pathRight;
    } else if (Blockly.blockRendering.Types.isLeftSquareCorner(elem)) {
      outlinePath += Blockly.utils.svgPaths.lineOnAxis("H", bottomRow.xPos);
    } else if (Blockly.blockRendering.Types.isLeftRoundedCorner(elem)) {
      outlinePath += this.constants_.OUTSIDE_CORNERS.bottomLeft;
    } else if (Blockly.blockRendering.Types.isRightRoundedCorner(elem)) {
      outlinePath += this.constants_.OUTSIDE_CORNERS.bottomRight;
      rightCornerYOffset = this.constants_.INSIDE_CORNERS.rightHeight; //右侧距离头部的位置
    } else if (Blockly.blockRendering.Types.isSpacer(elem)) {
      outlinePath += Blockly.utils.svgPaths.lineOnAxis("h", elem.width * -1);
    }
  }

  this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis(
    "V",
    bottomRow.baseline - rightCornerYOffset
  );
  this.outlinePath_ += outlinePath; //默认
  // console.log("drawBottom_:" + this.outlinePath_);
};

/**
 * Add steps for the right side of a row that does not have value or
 * statement input connections.
 * 没有值的或语句输入连接
 * @param {!Blockly.blockRendering.Row} row The row to draw the
 *     side of.
 * @protected
 */
Blockly.gta.Drawer.prototype.drawRightSideRow_ = function(row) {
  var remainingHeight = 0;
  if (
    row.type &
    Blockly.blockRendering.Types.getType("BEFORE_STATEMENT_SPACER_ROW")
  ) {
    remainingHeight = row.height - this.constants_.INSIDE_CORNERS.rightWidth;
    this.outlinePath_ +=
      (remainingHeight > 0
        ? Blockly.utils.svgPaths.lineOnAxis("V", row.yPos + remainingHeight)
        : "") + this.constants_.INSIDE_CORNERS.pathTopRight;
    // console.log("Row_1:" + this.outlinePath_);
  } else if (
    row.type &
    Blockly.blockRendering.Types.getType("AFTER_STATEMENT_SPACER_ROW")
  ) {
    remainingHeight = row.height - this.constants_.INSIDE_CORNERS.rightWidth;
    this.outlinePath_ +=
      this.constants_.INSIDE_CORNERS.pathBottomRight +
      (remainingHeight > 0
        ? Blockly.utils.svgPaths.lineOnAxis("V", row.yPos + row.height)
        : "");
    // console.log("Row_2:" + this.outlinePath_);
  } else {
    this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis(
      "V",
      row.yPos + row.height
    );
    // console.log("Row_3:" + this.outlinePath_);
  }
};

/**
 * Add steps to draw the right side of an output with a dynamic connection.
 * 右侧输出动态连接
 * @protected
 */
Blockly.gta.Drawer.prototype.drawRightDynamicConnection_ = function() {
  // debugger;
  this.outlinePath_ += this.info_.outputConnection.shape.pathRightDown(
    this.info_.outputConnection.height
  );
};

// 左侧直线加粗
Blockly.gta.Drawer.prototype.boldLefyByLine = function(startX, startY, top) {
  var leftLine = "M" + startX + " " + startY + "V" + top + "Z";
  this.outlinePath_ += leftLine;
};
// 左侧八边形折线加粗
Blockly.gta.Drawer.prototype.boldLeftByBrokenLine = function(startX, startY) {
  // 改变totalHeight;
  // debugger;
  // var startY = this.info_.bottomRow.baseline;
  var totalHeight = startY;
  var height_1 = Number((totalHeight / 4).toFixed(0));
  var height_2 = totalHeight - 2 * height_1;
  var height_3 = -height_1;
  var height_4 = -height_2;
  var width_1 = height_1;
  var width_2 = -width_1;
  var pathRight =
    "M" +
    startX +
    "," +
    startY +
    " " +
    "l" +
    width_2 +
    "," +
    height_3 +
    " " +
    "0" +
    "," +
    height_4 +
    " " +
    width_1 +
    "," +
    height_3;

  return pathRight;
};

/**
 * Add steps to draw the left side of an output with a dynamic connection.
 * 左侧动态连接
 * @protected
 */
Blockly.gta.Drawer.prototype.drawLeftDynamicConnection_ = function() {
  var topRow = this.info_.topRow;
  var startX_1 = 1;
  var startX_2 = 1.05;
  var startX_3 = 1.15;
  var startY = this.info_.outputConnection.height;

  this.positionOutputConnection_();
  // 增，改，自定义积木路径
  if (this.block_.type == "gta_ai_event_1") {
    this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis("H", topRow.xPos);
    this.outlinePath_ += "z";
    // 调用，左边直线加粗
    // debugger;

    this.boldLefyByLine(topRow.xPos - 1, startY, -10);
    this.boldLefyByLine(topRow.xPos + 1, startY, -10);
    return;
  }

  //改， 内置积木路径
  this.outlinePath_ += this.info_.outputConnection.shape.pathUp(
    this.info_.outputConnection.height
  );
  this.outlinePath_ += "z";
  // debugger
  // 改，增，积木左边的加粗线条
  var left_path =
    "m" +
    startX_1 +
    "," +
    startY +
    " " +
    this.info_.outputConnection.shape.pathUp(
      this.info_.outputConnection.height
    );
  var left_path_2 =
    "m" +
    startX_2 +
    "," +
    startY +
    " " +
    this.info_.outputConnection.shape.pathUp(
      this.info_.outputConnection.height
    );
  var left_path_3 =
    "m" +
    startX_3 +
    "," +
    startY +
    " " +
    this.info_.outputConnection.shape.pathUp(
      this.info_.outputConnection.height
    );
  // console.log("left_path:" + left_path);
  this.outlinePath_ += left_path;
  this.outlinePath_ += left_path_2;
  this.outlinePath_ += left_path_3;
  // console.log("drawLeftDynamicConnection_2:" + this.outlinePath_);
};

/**
 * Add steps to draw a flat top row.
 * 平顶行的路径
 * @protected
 */
Blockly.gta.Drawer.prototype.drawFlatTop_ = function() {
  var topRow = this.info_.topRow;
  topRow.xPos = topRow.xPos;

  this.positionPreviousConnection_();
  if (this.block_.type == "gta_ai_event_1") {
    // 自定义积木
    this.outlinePath_ += Blockly.utils.svgPaths.moveBy(
      topRow.xPos,
      this.info_.startY - 10
    );
    this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis(
      "h",
      topRow.width / 2
    );
    this.outlinePath_ += Blockly.utils.svgPaths.lineTo(10, 10);
    this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis(
      "h",
      (topRow.width * 1) / 2
    );
    return;
  }
  // 默认积木头部
  this.outlinePath_ += Blockly.utils.svgPaths.moveBy(
    topRow.xPos,
    this.info_.startY
  );
  // "logic_null"逻辑空积木宽度加长
  if (this.block_.type == "logic_null") {
    this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis(
      "h",
      topRow.width * 2
    );
  } else {
    this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis("h", topRow.width);
  }

  // console.log("drawFlatTop_:" + this.outlinePath_);
};

/**
 * Add steps to draw a flat bottom row.
 * 底部的路径
 * @protected
 */
Blockly.gta.Drawer.prototype.drawFlatBottom_ = function() {
  var bottomRow = this.info_.bottomRow;
  this.positionNextConnection_();

  this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis(
    "V",
    bottomRow.baseline
  );

  if (this.block_.type == "logic_null") {
    this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis(
      "h",
      -bottomRow.width * 2
    );
    // debugger;
  } else {
    this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis(
      "h",
      -bottomRow.width
    );
  }
  // console.log("drawFlatBottom_:" + this.outlinePath_);
};

/**
 * @override
 * 内部输入的连接
 */
Blockly.gta.Drawer.prototype.drawInlineInput_ = function(input) {
  // Don't draw an inline input.
  this.positionInlineInputConnection_(input);
};

// 自定义积木的左侧路径加粗
Blockly.gta.Drawer.prototype.drawLeft_ = function() {
  // console.log(this.block_.type);
  var TAB_HEIGHT = this.constants_.TAB_HEIGHT; //左侧输出的高度
  var TAB_WIDTH = this.constants_.TAB_WIDTH; //左侧输出的高度
  var outputConnection = this.info_.outputConnection;
  // 外框左侧的高度
  var startY = this.info_.bottomRow.baseline;
  var startX = this.info_.startX;
  // debugger;
  this.positionOutputConnection_();
  if (outputConnection) {
    var tabBottom =
      outputConnection.connectionOffsetY + outputConnection.height; //默认
    var totalHeight = TAB_HEIGHT;
    // 变量积木的左边形状

    if (
      this.info_.outputConnection &&
      !this.info_.outputConnection.isDynamic()
      // this.block_.type == "variables_get" ||
      // this.block_.type == "gta_ai_item"
    ) {
      // 改变totalHeight;
      totalHeight = startY;
    }
    var height_1 = (totalHeight / 4).toFixed(2);
    var height_2 = totalHeight - 2 * height_1;
    var height_3 = -height_1;
    var height_4 = -height_2;
    var width_1 = height_1;
    // var width_1 = TAB_WIDTH;
    var width_2 = -width_1;
    var pathRight =
      "l" +
      width_2 +
      "," +
      height_3 +
      " " +
      "0" +
      "," +
      height_4 +
      " " +
      width_1 +
      "," +
      height_3 +
      " ";
    // this.outlinePath_ += pathRight;
    if (
      this.info_.outputConnection &&
      !this.info_.outputConnection.isDynamic()
    ) {
      this.outlinePath_ += pathRight; //修改v
      this.outlinePath_ += "z";
      this.outlinePath_ += this.boldLeftByBrokenLine(startX - 1, startY);
      this.outlinePath_ += this.boldLeftByBrokenLine(startX + 1, startY);
      // console.log("drawLeft_:" + this.outlinePath_);
      return;
    }
    this.outlinePath_ +=
      Blockly.utils.svgPaths.lineOnAxis("V", tabBottom) + pathRight; //修改v
    this.outlinePath_ += "z";
    // console.log("drawLeft_:" + this.outlinePath_);
    return;
  }
  this.outlinePath_ += "z";
  // 左侧线条加粗 top=0;
  this.boldLefyByLine(-1, startY, 0);
  this.boldLefyByLine(2, startY, 0);
  this.boldLefyByLine(1, startY, 0);
  // console.log("drawLeft_:" + this.outlinePath_);
};

/**
 * Add highlighting around this connection.
 * 高亮连接的提示
 */
Blockly.RenderedConnection.prototype.highlight = function() {
  var steps;
  var sourceBlockSvg = /** @type {!Blockly.BlockSvg} */ (this.sourceBlock_);
  var renderingConstants = sourceBlockSvg.workspace
    .getRenderer()
    .getConstants();
  if (this.type == Blockly.INPUT_VALUE || this.type == Blockly.OUTPUT_VALUE) {
    // Vertical line, puzzle tab, vertical line.
    var yLen = 5;
    steps =
      Blockly.utils.svgPaths.moveBy(0, -yLen) +
      Blockly.utils.svgPaths.lineOnAxis("v", yLen) +
      renderingConstants.PUZZLE_TAB.pathDown +
      Blockly.utils.svgPaths.lineOnAxis("v", yLen);
  } else {
    var xLen = 5;
    // Horizontal line, notch, horizontal line.
    steps =
      Blockly.utils.svgPaths.moveBy(-xLen, 0) +
      Blockly.utils.svgPaths.lineOnAxis("h", xLen) +
      renderingConstants.NOTCH.pathLeft +
      Blockly.utils.svgPaths.lineOnAxis("h", xLen);
  }
  var xy = this.sourceBlock_.getRelativeToSurfaceXY();
  var x = this.x_ - xy.x;
  var y = this.y_ - xy.y;
  Blockly.Connection.highlightedPath_ = Blockly.utils.dom.createSvgElement(
    "path",
    {
      class: "blocklyHighlightedConnectionPath",
      // d: "m 0,0 l -6,6 v 10 l 6,6 ", //改
      d: steps,
      transform:
        "translate(" +
        x +
        "," +
        y +
        ")" +
        (this.sourceBlock_.RTL ? " scale(-1 1)" : "")
    },
    this.sourceBlock_.getSvgRoot()
  );
};

// 增，积木进行描边
Blockly.gta.Drawer.prototype.strokeOpacityTransform = function() {
  var styleName = this.block_.styleName_;
  var blocklyPath = this.block_.pathObject.svgPath;
  // debugger;
  if (styleName) {
    blocklyPath.setAttribute("stroke", "url(#" + styleName + ")");
  } else {
    //数据库获取的积木的描边样式处理
    blocklyPath.setAttribute("stroke", "url(#event_blocks)");
  }
};

// 增,右侧八边形
Blockly.gta.Drawer.prototype.rightHexagonal = function(totalHeight) {
  var height_1 = (totalHeight / 4).toFixed(0);
  var height_2 = totalHeight - 2 * height_1;
  var height_3 = -height_1;
  var pathRight =
    "l" +
    height_1 +
    "," +
    height_1 +
    " " +
    "0" +
    "," +
    height_2 +
    " " +
    height_3 +
    "," +
    height_1 +
    " ";
  return pathRight;
};

//积木下拉框样色的调整
Blockly.DropDownDiv.show = function(
  owner,
  rtl,
  primaryX,
  primaryY,
  secondaryX,
  secondaryY,
  opt_onHide
) {
  var styleName = owner.sourceBlock_.colour_;
  // debugger;
  // var styleName = owner.sourceBlock_.styleName_;
  Blockly.DropDownDiv.owner_ = owner;
  Blockly.DropDownDiv.onHide_ = opt_onHide || null;
  var metrics = Blockly.DropDownDiv.getPositionMetrics(
    primaryX,
    primaryY,
    secondaryX,
    secondaryY
  );

  if (metrics.arrowVisible) {
    Blockly.DropDownDiv.arrow_.style.display = "";
    Blockly.DropDownDiv.arrow_.style.transform =
      "translate(" +
      metrics.arrowX +
      "px," +
      metrics.arrowY +
      "px) rotate(45deg)";
    Blockly.DropDownDiv.arrow_.setAttribute(
      "class",
      metrics.arrowAtTop
        ? "blocklyDropDownArrow arrowTop"
        : "blocklyDropDownArrow arrowBottom"
    );
  } else {
    Blockly.DropDownDiv.arrow_.style.display = "none";
  }

  // Set direction.
  Blockly.DropDownDiv.DIV_.style.direction = rtl ? "rtl" : "ltr";
  Blockly.DropDownDiv.arrow_.setAttribute("class", "blocklyDropDownDiv");
  // debugger;
  Blockly.DropDownDiv.DIV_.style.background = this.getColor(styleName, "1");
  // Blockly.DropDownDiv.DIV_.style.background = this.getColor(styleName, "0.2");
  Blockly.DropDownDiv.DIV_.style.borderColor = styleName;

  Blockly.DropDownDiv.positionInternal_(
    metrics.initialX,
    metrics.initialY,
    metrics.finalX,
    metrics.finalY
  );
  return metrics.arrowAtTop;
};

//颜色转换器转成rgba
Blockly.DropDownDiv.getColor = function(hex, opacity) {
  return (
    "rgba(" +
    parseInt("0x" + hex.slice(1, 3)) +
    "," +
    parseInt("0x" + hex.slice(3, 5)) +
    "," +
    parseInt("0x" + hex.slice(5, 7)) +
    "," +
    opacity +
    ")"
  );
};

/**
 * Create a field border rect element. Not to be overridden by subclasses.
 * Instead modify the result of the function inside initView, or create a
 * separate function to call.
 * from ./field.js
 * @protected
 */
// 文本框背景填充颜色
Blockly.Field.prototype.createBorderRect_ = function() {
  this.size_.height = Math.max(
    this.size_.height,
    Blockly.Field.BORDER_RECT_DEFAULT_HEIGHT
  );
  this.size_.width = Math.max(this.size_.width, Blockly.Field.X_PADDING);
  this.borderRect_ = Blockly.utils.dom.createSvgElement(
    "rect",
    {
      rx: 4,
      ry: 6,
      // ry: 4,
      x: 0,
      y: 0,
      height: this.size_.height,
      width: this.size_.width
    },
    this.fieldGroup_
  );
  var color = this.sourceBlock_.colourSecondary_;

  this.borderRect_.style.fill = color;
  this.borderRect_.style.stroke = "none";
};

/**
 * Create a field text element. Not to be overridden by subclasses. Instead
 * modify the result of the function inside initView, or create a separate
 * function to call.
 *  * from ./field.js
 * @protected
 */
// 文本框字体填充颜色
Blockly.Field.prototype.createTextElement_ = function() {
  var xOffset = this.borderRect_ ? Blockly.Field.DEFAULT_TEXT_OFFSET : 0;
  this.textElement_ = Blockly.utils.dom.createSvgElement(
    "text",
    {
      class: "blocklyText",
      // The y position is the baseline of the text.
      y: Blockly.Field.TEXT_DEFAULT_HEIGHT,
      x: xOffset
    },
    this.fieldGroup_
  );
  this.textContent_ = document.createTextNode("");
  this.textElement_.appendChild(this.textContent_);
  this.textElement_.style.fill = "#fff";
};

Blockly.Field.X_PADDING = 10;
Blockly.Field.Y_PADDING = 0;

Blockly.Field.prototype.getScaledBBox_ = function() {
  var bBox = this.borderRect_.getBBox();
  var scaledHeight = bBox.height * this.sourceBlock_.workspace.scale;
  var scaledWidth = bBox.width * this.sourceBlock_.workspace.scale;
  var xy = this.getAbsoluteXY_();
  return {
    top: xy.y,
    bottom: xy.y + scaledHeight,
    left: xy.x,
    right: xy.x + scaledWidth
  };
};


// 设置输入框的样式input样式，使其可以兼容多行输入文本。 
// Blockly.FieldTextInput.prototype.widgetCreate_ = function() {
//   var div = Blockly.WidgetDiv.DIV;

//   var htmlInput = /** @type {HTMLInputElement} */ (document.createElement('textarea'));
//   htmlInput.className = 'blocklyHtmlInput blocklyHtmlTextAreaInput';
//   htmlInput.setAttribute('rows','auto');
//   htmlInput.setAttribute('spellcheck', this.spellcheck_);
//   var fontSize =
//       (Blockly.FieldTextInput.FONTSIZE * this.workspace_.scale) + 'pt';
//   div.style.fontSize = fontSize;
//   htmlInput.style.fontSize = fontSize;
//   var borderRadius = (Blockly.FieldTextInput.BORDERRADIUS * this.workspace_.scale) + 'px';
//   htmlInput.style.borderRadius = borderRadius;
//   div.appendChild(htmlInput);

//   htmlInput.value = htmlInput.defaultValue = this.getEditorText_(this.value_);
//   htmlInput.untypedDefaultValue_ = this.value_;
//   htmlInput.oldValue_ = null;
//   if (Blockly.utils.userAgent.GECKO) {
//     // In FF, ensure the browser reflows before resizing to avoid issue #2777.
//     setTimeout(this.resizeEditor_.bind(this), 0);
//   } else {
//   this.resizeEditor_();
//   }

//   this.bindInputEvents_(htmlInput);

//   return htmlInput;
// };